import { gql } from "graphql-request";

export const splitMaximumAmount = gql`
  query SplitAmount($maximumAmount: Float!) {
    splitMaximumAmount(maximumAmount: $maximumAmount) {
      userId
      username
      role
      splitAmount
    }
  }
`;
export const salesRolesUsers = gql`
  query {
    salesRolesUsers {
      id
      username
    }
  }
`;
export const createSalestargetdetails = gql`
  mutation createsalestarget($input: CreateSalesTargetDetailsInput!) {
    createSalestargetdetails(input: $input) {
      success
    }
  }
`;
export const allSalestargetdetails = gql`
  query {
    allSalestargetdetails {
      id
      user {
        username
      }
      targetAmount
      salesTarget {
        id
        financialYear
        maximumAmount
        minimumAmount
        productCategory
        salesTerritory
        businessLine
      }
      monthlytargetSet {
        createdAt
      }
    }
  }
`;

export const salesTargetDetailsById = gql`
  query GetSalesTargetById($id: String!) {
    salesTargetDetailsById(id: $id) {
      name
      targetAmount
      salesTarget {
        financialYear
        months
      }
    }
  }
`;

export const createMonthlyTarget = gql`
  mutation monthlytarget($input: CreateMonthlyTargetsInput!) {
    createMonthlyTarget(input: $input) {
      success
    }
  }
`;

export const salesTargetGetById = gql`
  query getmonthly($id: String!) {
    salesTargetGetById(id: $id) {
      user {
        id
        username
      }
      salesTarget {
        financialYear
      }
      targetAmount
      monthlytargetSet {
        id
        monthYear
        targetAmount
      }
    }
  }
`;

export const UpdateMonthlyTargets = gql`
  mutation UpdateMonthlyTargets($monthlyTargets: [UpdateMonthlyTargetInput]!) {
    updateMonthlyTarget(monthlyTargets: $monthlyTargets) {
      success
    }
  }
`;
export const allSalestargetdetailsView = gql`
  query {
    allSalesTarget {
      id
      user {
        username
      }
      maximumAmount
      minimumAmount
      financialyearStart
      financialyearEnd
      salestargetSet {
        id
        user {
          username
        }
        targetAmount
      }
    }
  }
`;

export const salesTargetDetailsGetById = gql`
  query getSalesTargetById($id: String!) {
    salesTargetDetailsGetById(id: $id) {
      user {
        username
      }
      financialyearStart
      financialyearEnd
      maximumAmount
      minimumAmount
      salestargetSet {
        id
        user {
          username
        }
        targetAmount
      }
    }
  }
`;
export const updateSalestargetdetails = gql`
  mutation updatesalestarget($input: UpdateSalesTargetDetailsInput!) {
    updateSalestargetdetails(input: $input) {
      success
    }
  }
`;

export const getSalestargetDetailByUser = gql`
  query getuser($id: String!) {
    getSalestargetDetailByUser(id: $id) {
      user {
        username
      }
      salesTarget {
        financialYear
      }
      targetAmount
      monthlytargetSet {
        monthYear
        targetAmount
      }
    }
  }
`;

export const getSalestargetDetailByMaster = gql`
  query getmaster($id: String!) {
    getSalestargetDetailByMaster(id: $id) {
      id

      targetAmount

      user {
        username
      }

      salesTarget {
        id

        financialYear

        maximumAmount

        minimumAmount
      }
    }
  }
`;
